export const TRACK_REQUIRED_VALUES = ['genre', 'owner_id', 'title']
export const MAX_DESCRIPTION_LENGTH = 2500
